import React, { useEffect, useState, useRef } from 'react';
export function ClientLogos() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const logos = [{
    name: 'Premier Roofing Company',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dp2V9t4KBqtNRKwEZ16zWE/Premier-Roofing-Logo-800.webp'
  }, {
    name: 'Typeform VideoAsk',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mz7NLRgHxHC3R8RzF3YCkX/TypeformVideoAsk_Transparent.png'
  }, {
    name: 'Chipr',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mWRbtmgL6tZDZ35pDz81aY/ChiprLogo__1_.png'
  }, {
    name: 'GoHighLevel',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qPbuvohPjZaBcU1aJP17AB/GHL_Logo_512x512_px.png'
  }, {
    name: 'Typeform',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/czCVSeeqm1K8BeLBVx28SK/Typeform_Cover_280x100_px.png'
  }, {
    name: 'Texas Direct Roofing & Construction',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iwFeaPd9UVERwxAky4N5Te/TypeformVideoAsk_Transparent.png'
  }, {
    name: 'Median Energy',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/84u9Gp2QPa7E6EJEpaZ3NU/ME.Typeform_Transparent.png'
  }, {
    name: 'NTY Windows',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5rxA7Dx3FrGrd5EKoo7eMc/GHL_Logo_512x512_px_%285%29.png'
  }, {
    name: 'The Pest Cooperative',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rozhvnKso1kGCKfajhAG4W/TypeformVideoAsk_Transparent_-_Pest_Cooperative.png'
  }, {
    name: 'Freedom WISP',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2FvmcCdQfLDAms5XrgWX9z/Freedom_WISP.jpg'
  }];
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;
    let scrollPosition = 0;
    let animationFrameId: number;
    // Slower, consistent speed
    const speed = 0.35;
    const animate = () => {
      if (scrollContainer) {
        scrollPosition += speed;
        // Get the width of one set of logos
        const firstChild = scrollContainer.firstElementChild as HTMLElement;
        if (firstChild) {
          const setWidth = firstChild.offsetWidth;
          // Reset position when we've scrolled one full set
          if (scrollPosition >= setWidth) {
            scrollPosition = 0;
          }
          scrollContainer.style.transform = `translateX(-${scrollPosition}px)`;
        }
      }
      animationFrameId = requestAnimationFrame(animate);
    };
    animationFrameId = requestAnimationFrame(animate);
    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
  return <section className="py-12 bg-gray-50 relative" data-id="element-92">
      <div className="container-custom" data-id="element-93">
        <div className="text-center mb-8" data-id="element-94">
          <p className="text-sm font-semibold text-gray-500 uppercase tracking-wide" data-id="element-95">
            Trusted by 40+ D2D & Direct Sales Companies
          </p>
        </div>
      </div>

      {/* Scrolling container - full width, outside container */}
      <div className="relative overflow-hidden" data-id="element-96">
        {/* Wrapper with three identical sets for smooth infinite scroll */}
        <div ref={scrollRef} className="flex items-center" style={{
        willChange: 'transform'
      }} data-id="element-97">
          {/* Render logos 3 times for seamless loop */}
          {[0, 1, 2].map(setIndex => <div key={setIndex} className="flex items-center flex-shrink-0" data-id="element-98">
              {logos.map((logo, index) => <div key={`${setIndex}-${index}`} className="flex-shrink-0 mx-3 md:mx-6 flex items-center justify-center" data-id="element-99">
                  <div className="w-24 h-16 md:w-40 md:h-20 lg:w-44 lg:h-24 bg-white rounded border border-gray-200 flex items-center justify-center p-3 md:p-5 shadow-sm" data-id="element-100">
                    <img src={logo.url} alt={logo.name} className="max-w-full max-h-full w-auto h-auto object-contain" data-id="element-101" />
                  </div>
                </div>)}
            </div>)}
        </div>

        {/* Gradient overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-20 md:w-32 lg:w-40 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none" data-id="element-102"></div>
        <div className="absolute right-0 top-0 bottom-0 w-20 md:w-32 lg:w-40 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none" data-id="element-103"></div>
      </div>
    </section>;
}